import React, { Component } from "react";
import photo from "../../../assets/images/DENT_PHOTO_ICON.png";
import firebaseManager from "../../../model/Firebase/FirebaseManager";

class ImageUpload extends Component {
  constructor(props) {
    super();
    this.state = {
      image: null,
      url1: "",
      url2: "",
      url3: "",
      uploadValue: 0,
    };
    this.handleUpload = this.handleUpload.bind(this);
  }

  handleUpload = (e) => {
    const file = e.target.files[0];
    firebaseManager.saveImage(file, this.imageSuccess, this.imageFailError);
    document
      .getElementById(`${this.props.id}loader`)
      .classList.remove("d-none");
    document.getElementById(`${this.props.id}image`).classList.add("d-none");
  };

  imageSuccess = (url) => {
    if (url) {
      document.getElementById(`${this.props.id}image`).src = url;
      document.getElementById(`${this.props.id}loader`).classList.add("d-none");
      document
        .getElementById(`${this.props.id}image`)
        .classList.remove("d-none");
      this.props.successImage(url, this.props.id);
    }
  };

  imageFailError(error) {
    this.props.failImage(error, this.props.id);
  }

  render() {
    return (
      <div className="text-center">
        <div id="Selector">
          <input
            type="file"
            accept="image/png, .jpeg, .jpg"
            id={`${this.props.id}photo`}
            className="SubirFoto"
            onChange={this.handleUpload}
          />
          <label htmlFor={`${this.props.id}photo`}>
            <div
              id={`${this.props.id}loader`}
              className="lds-spinner mt-2 d-none"
            >
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <img
              className=""
              id={`${this.props.id}image`}
              src={photo}
              widht="150"
              height="130"
              alt="Uploaded images"
            />
          </label>
        </div>
      </div>
    );
  }
}

export default ImageUpload;
